const landPageMap = {
  // 获取落地页配置
  getLandPageConfig: '/usb/uwb-app/api/v1/lp/config',
  // 获取落地页商品列表
  getLandPageProduct: '/usb/uwb-app/api/v1/lp/page',
};

export default landPageMap;
